import React, {useContext, useEffect, useState} from 'react';
import {CartContext} from 'contexts/cart/cart.context';
import {
    CartPopupBody,
    CheckoutButton,
    CheckoutButtonWrapper,
    CloseButton,
    DatePickerWrapper,
    DeleteButton,
    ItemCards,
    ItemDetails,
    ItemImgWrapper,
    ItemPrice,
    ItemTitle,
    ItemWrapper,
    NoProductMsg,
    PopupHeader,
    PopupItemCount,
    PriceBox,
    Title,
    TotalPrice,
} from './CartItemCard.style';
import {CloseIcon, ShoppingBagLarge} from 'components/AllSvgIcon';
import InputNumber from 'components/InputIncDec/InputIncDec';
import {CURRENCY} from 'helper/constant';
import {CartProduct} from 'interfaces';
import {FormattedMessage} from 'react-intl';

import {Scrollbars} from 'react-custom-scrollbars';
import moment from "moment-timezone";
import Router from "next/router";
import Loader from "../../components/Loader/Loader";
import Modal from "components/Modal";
import TripDatesModal from "containers/TripDatesModal/TripDatesModal";
import {ProductTypeEnum} from "API";
import Tooltip from "components/Tooltip";
import {StockItemContext} from "contexts/stock/stock.provider";

type CartItemProps = {
    product: CartProduct;
    update: Function;
};

type CartPropsType = {
    scrollbarHeight?: string;
    onCloseBtnClick?: (e: any) => void;
};


const CartItem: React.FC<CartItemProps> = ({product, update}) => {
    const {getProductPrice, cart: {tripDays, orderStartTime, orderEndTime, stockLocation}} = useContext(CartContext);
    const {getCachedAvailableQty} = useContext(StockItemContext);
    const [image, setImage] = useState(null);

    useEffect(() => {
        if (product) {
            setImage(product.image?.url ?? product.media?.items[0]?.media?.url);
        }
    }, [product]);

    const availableQty = getCachedAvailableQty(product.id, orderStartTime, orderEndTime, stockLocation);
    const stockLimitReached = product.qty >= getCachedAvailableQty(product.id, orderStartTime, orderEndTime, stockLocation);

    console.log(availableQty)
    return (
        <ItemCards key={product.id}>
            <InputNumber
                disabled={stockLimitReached}
                type='vertical'
                value={product.qty}
                onUpdate={(value: number) => update(product.id, value)}
                style={{marginRight: 15}}
            />

            <ItemImgWrapper>
                <img
                    className='ListImage'
                    src={image}
                    height='150'
                    width='150'
                />
            </ItemImgWrapper>

            <ItemDetails>
                <ItemTitle>{product.name}</ItemTitle>
                <ItemPrice>
                    {CURRENCY}
                    {getProductPrice(tripDays, product.price, product.type).toFixed(2)}
                    {product.type === ProductTypeEnum.RETAIL_ITEM ? ' (buy)' : "/day"}
                </ItemPrice>
                {
                    product.depositTotal && product.depositTotal > 0 ?
                        <div className="text-xs text-gray-500 font-base tracking-wide">
                            Deposit: R {product.depositTotal}
                        </div> : null
                }
                {
                    product.discountTotal > 0 ?
                        <div>
                        <span
                            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-orange-100 text-orange-800">
                         You save R {product.discountTotal?.toFixed(2)}
                        </span></div> : null
                }

                {/*Check the available stock total with every update and disable the button if they want to go over */}
                {/*the available stock levels*/}
                {
                    stockLimitReached &&
                    <div className="w-full text-red-500 text-xs tracking-wide">
                        Contact us to book {availableQty + 1}+
                    </div>
                }


            </ItemDetails>
            <TotalPrice>
                R {product.total.toFixed(2)}
            </TotalPrice>

            <DeleteButton onClick={() => update(product.id, 0)}>
                <CloseIcon/>
            </DeleteButton>
        </ItemCards>
    );
};


const Cart: React.FC<CartPropsType> = ({
                                           onCloseBtnClick,
                                           scrollbarHeight,
                                       }) => {
    const {
        toggle,
        clearCart,
        cart: {
            products,
            total,
            subTotal,
            discountTotal,
            couponDiscountTotal,
            tripDiscountTotal,
            depositTotal,
            orderStartTime,
            orderEndTime,
            tripDays
        }, update,
    } = useContext(CartContext);
    const [modalOpen, setModalOpen] = useState(null);


    const [dateHeading, setDateHeading] = useState(null);
    const [daysCount, setDaysCount] = useState(null);
    const [checkoutButtonText, setCheckoutButtonText] = useState(null);
    const [checkoutLoading, setCheckoutLoading] = useState(null);


    useEffect(() => {
        // Hack to try and auto-hide the address bar
        // https://developers.google.com/web/fundamentals/native-hardware/fullscreen
        window.scrollTo(0, 1);
    }, [])


    useEffect(() => {
        if (orderStartTime && orderEndTime) {
            setDateHeading(<div className="flex justify-center">
                <h3>{`${moment(orderStartTime).format('ddd DD MMM')} - ${moment(orderEndTime).format('ddd DD MMM')}`}</h3>
                <span className='text-green-500 ml-2 cursor-pointer' onClick={showDatesModal}>
                    <svg
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="pencil-alt w-5 h-5"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                    </svg>
                </span>
            </div>);
            setDaysCount(<>
                {tripDays}{" "}
                <FormattedMessage id={tripDays > 1 ? 'days' : 'day'} defaultMessage={tripDays > 1 ? 'days' : 'day'}/>
            </>);
        } else {

            setDateHeading(<div className="flex justify-center">
                <h3>Please select your rental dates</h3>
                <span className='text-green-500 ml-2 cursor-pointer' onClick={showDatesModal}>
                    <svg
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="pencil-alt w-5 h-5"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                    </svg>
                </span>
            </div>)
            setCheckoutButtonText(<FormattedMessage id='selectTripDates'
                                                    defaultMessage={`Please select your rental dates`}/>)
        }
    }, [tripDays, orderStartTime, orderEndTime]);


    function showDatesModal() {
        setModalOpen(<Modal open={true}
                            onClose={() => setModalOpen(null)}
                            content={<TripDatesModal onOk={() => setModalOpen(null)}/>}
                            contentClasses={"overflow-visible"}
        />);
    }


    const onCheckoutClick = (e) => {
        setCheckoutLoading(true);
        Router.push('/checkout');
    }

    const onAddProductsClick = () => {
        Router.push('/camping');
        toggle();
    }

    return (
        <>
            {modalOpen}

            <CartPopupBody>

                <PopupHeader>
                    <PopupItemCount>
                        <ShoppingBagLarge width='19px' height='24px'/>
                        <span>
                            {products && products.length}{' '}
                            {products.length === 1 ? 'item' : 'items'}
                          </span>
                    </PopupItemCount>

                    <div className="flex gap-4 items-center">
                        <CloseButton onClick={onCloseBtnClick}>
                            <CloseIcon/>
                        </CloseButton>
                    </div>
                </PopupHeader>

                <Scrollbars universal autoHide autoHeight autoHeightMax={scrollbarHeight}>

                    <ItemWrapper>
                        <DatePickerWrapper>
                            <h3 className='product-title'>{dateHeading}</h3>
                            <h6 className='product-title'>{daysCount}</h6>
                        </DatePickerWrapper>
                        {products && products.length ? (
                            products.map(item => (
                                <CartItem
                                    key={`cartItem-${item.id}`}
                                    update={update}
                                    product={item}
                                />
                            ))
                        ) : (
                            <>
                                <NoProductMsg>
                                    <FormattedMessage
                                        id='noProductFound'
                                        defaultMessage='Your cart is empty'
                                    />

                                </NoProductMsg>
                                <div className="w-2/3 m-auto flex justify-center">
                                    <span className="inline-flex rounded-full shadow-sm">
                                      <button
                                          onClick={onAddProductsClick}
                                          type="button"
                                          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-bold rounded-full text-white bg-scuttle-blue hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
                                        Add Products Now
                                      </button>
                                    </span>
                                </div>
                            </>
                        )}
                    </ItemWrapper>
                </Scrollbars>


                <CheckoutButtonWrapper>
                    <div className="mx-4 mt-4 p-4 ">
                        <div className="flex justify-between flex-row">
                            <p className="text-gray-500">Product Booking {
                                tripDiscountTotal > 0 && <>
                                            <span
                                                className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-orange-100 text-orange-800">
                                     You save R {tripDiscountTotal.toFixed(2)}
                                    </span>
                                </>
                            }</p>
                            <p className="text-gray-700 font-bold justify-end">R {(subTotal - tripDiscountTotal)?.toFixed(2)}</p>
                        </div>

                        {couponDiscountTotal > 0 && <>
                            <div className="flex justify-between  flex-row">
                                <div>
                                    <p className="text-gray-500">
                                        Coupon Discount <span className="inline-flex text-scuttle-orange text-xs">* Rental items only</span>
                                    </p>

                                </div>
                                <p className="text-gray-700 font-bold justify-end">(R {couponDiscountTotal.toFixed(2)})</p>
                            </div>
                            <div className="mt-1 flex justify-between  flex-row border-t">
                                <p className="mt-1 text-gray-500">Subtotal</p>
                                <p className="text-gray-700 font-bold justify-end">R {total.toFixed(2)}</p>
                            </div>
                        </>}
                        <div className="flex justify-between flex-row">
                            <div className="flex items-center">
                                <p className="text-gray-500">Refundable Deposit</p>
                                <Tooltip
                                    text={'We charge a refundable deposit which will be refunded to you once we have checked your returned products.'}/>

                            </div>
                            <p className="text-gray-700 font-bold justify-end">R {depositTotal.toFixed(2)}</p>
                        </div>
                        <div className="flex justify-between flex-row mt-1">
                            <div className="flex items-center">
                                <svg className="w-4 h-4 text-scuttle-orange " fill="none" stroke="currentColor"
                                     viewBox="0 0 24 24"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/>
                                </svg>
                                {" "}
                                <p className="text-scuttle-orange text-xs font-semibold">Free delivery R2500+ (excl.
                                    deposit)</p>
                            </div>
                        </div>
                    </div>

                    {
                        products.length > 0 && (
                            <>
                                <CheckoutButton onClick={onCheckoutClick}>
                                    <>
                                        <Title>
                                            Proceed to Checkout
                                        </Title>
                                        <PriceBox>
                                            {checkoutLoading ? <Loader color='#f15331'/> : <>R
                                                {parseFloat(`${total + depositTotal}`).toFixed(2)}</>}
                                        </PriceBox>
                                    </>
                                </CheckoutButton>
                            </>

                        )
                    }
                </CheckoutButtonWrapper>
            </CartPopupBody>
        </>
    );
};

export default Cart;
